import { render, staticRenderFns } from "./CargasMasivasSAE.vue?vue&type=template&id=c71f0f06&"
import script from "./CargasMasivasSAE.vue?vue&type=script&lang=js&"
export * from "./CargasMasivasSAE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports